import { api } from "@/lib/api";
import { clearConfig, clearResident, clearUser } from "@/lib/auth";
import { clearToken, setToken } from "@/lib/cookies";
import type { CheckLoginSchema, CheckResetSchema, LoginSchema, ResetSchema } from "./login.schema";


export async function checkLoginController(data: LoginSchema | CheckLoginSchema) {
	const res = await api.post("/auth/check-login", data);
	const response = res.data;

	if (response.data.access_token) {
		setToken(response.data.access_token);
	}
	return response;
}

export async function loginController(data: LoginSchema) {
	const res = await api.post("/auth/login", data);
	const response = res.data;
	setToken(response.data.access_token);
	return response;
}

export async function checkResetController(data: CheckResetSchema) {
	const res = await api.post("/auth/reset-password", data);
	const response = res.data;

	return response;
}

export async function resetController(data: ResetSchema) {
	const res = await api.post("/auth/password-reset", data);
	const response = res.data;
	return response;
}

export async function logoutController() {
	const res = await api.post("/auth/logout");
	clearToken();
	clearUser();
	clearResident();
	clearConfig();
	return res.data;
}